import React, { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RefreshEventPanelProvider } from '../event-panel/refresh-event-panel';
import { useIntegratedEventState } from '../event-panel/event-state/use-integrated-event-state';
import { EventMetadataProvider } from '../event-panel/event-panel-form/event-metadata';
import { useEventApi } from '../event-panel/event-api/use-event-api';
import { IntegratedFormProvider } from '../forms/integrated-form-provider';
import {
    FR_CREATE_EVENT_SUB_PATH,
    FR_EDIT_EVENT_SUB_PATH,
    FR_EVENT_ROOT_PATH,
} from '../router/constants';
import { toJS } from 'mobx';
import { EventPanelUnitsProvider } from '../event-panel/units/event-panel-units-provider';

export function FrEventPanelProvider({
    children,
    eventId,
}: PropsWithChildren<{ eventId?: number }>) {
    const location = useLocation();

    const { eventForm, eventQuery, refreshEventData, eventMetadataStore } = useIntegratedEventState(
        {
            eventId,
            queryOptions: {
                cacheTime: Infinity,
            },
        }
    );

    const { saveEventMutation, onSubmit } = useEventApi({
        eventMetadataStore,
        eventForm,
    });

    useEffect(() => {
        const previousPath = location.state?.previousLocationPathname;

        if (
            previousPath === `${FR_EVENT_ROOT_PATH}/${FR_CREATE_EVENT_SUB_PATH}` ||
            previousPath === `${FR_EVENT_ROOT_PATH}/${eventId}/${FR_EDIT_EVENT_SUB_PATH}`
        ) {
            eventQuery.refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state?.previousLocationPathname]);

    return (
        <EventMetadataProvider value={eventMetadataStore}>
            <RefreshEventPanelProvider value={refreshEventData}>
                <EventPanelUnitsProvider
                    initialUnits={toJS(eventMetadataStore?.state.metadata?.pillUnits)}
                    eventId={eventId}
                >
                    <IntegratedFormProvider
                        form={eventForm}
                        query={eventQuery}
                        onSubmit={onSubmit}
                        mutation={saveEventMutation}
                    >
                        {children}
                    </IntegratedFormProvider>
                </EventPanelUnitsProvider>
            </RefreshEventPanelProvider>
        </EventMetadataProvider>
    );
}
